@import 'src/global/media_queries'
  
:host 
  display: block
